var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8,9.6c1.3,0,2.5-0.5,3.5-1.4c1-0.9,1.4-2.1,1.4-3.4c0-1.3-0.5-2.5-1.4-3.4C12.3,0.5,11.1,0,9.8,0C8.5,0,7.3,0.5,6.3,1.4 S4.9,3.5,4.9,4.8c0,1.3,0.5,2.5,1.4,3.4C7.3,9.2,8.5,9.6,9.8,9.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4,16.4c0-0.4-0.1-1.8-0.2-2.3c-0.1-0.5-0.2-0.9-0.3-1.3c-0.1-0.4-0.3-0.8-0.5-1.2c-0.2-0.4-0.5-0.7-0.8-1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.4-0.2-0.9-0.3-1.5-0.3c-0.2,0-0.4,0.1-0.8,0.3c-0.2,0.2-0.5,0.3-0.8,0.5c-0.3,0.2-0.6,0.3-1.1,0.5 c-0.4,0.1-0.9,0.2-1.3,0.2S9,11.1,8.6,11c-0.4-0.1-0.8-0.3-1.1-0.5c-0.3-0.2-0.6-0.4-0.8-0.5C6.3,9.7,6.1,9.7,5.9,9.7 c-0.5,0-1,0.1-1.5,0.3c-0.4,0.2-0.8,0.4-1.2,0.7c-0.3,0.3-0.6,0.6-0.8,1C2.3,12,2.1,12.4,2,12.8c-0.1,0.4-0.2,0.8-0.3,1.3 c-0.1,0.4-0.1,1.9-0.2,2.3c0,0.4,0,0.8,0,1.2c0,0.6,0.3,1.2,1,1.9C3.1,20,4,20,5,20h9.8c1.1,0,1.9,0,2.6-0.6c0.7-0.6,1-1.1,1-1.9 C18.4,17.2,18.4,16.8,18.4,16.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d3d9ae56.svg";
export { ForwardRef as ReactComponent };